import $ from 'jquery';
(function(){
    'use strict';

    let typeOfFeedback;

    function reset() {
        $('.feedback').animate({right: "-297px"}, 600);
        setTimeout(resetAfterWindowGone, 800);   
    }
    
    function resetAfterWindowGone() {
        $('.feedback__input-wrapper label').empty();
        $('.feedback-window--input .feedback__input-form').trigger("reset");
        $('.feedback-window--input .feedback__main-option').remove();
        $('.feedback-window--input .feedback__main-option label').text('');
        typeOfFeedback = '';
        $('.feedback-window--type').removeClass('active');
        $('.feedback-window--input').removeClass('active');
        $('.feedback-window--success').removeClass('active');
        $('.feedback-window--main').addClass('active');

        // remove error message if present
        $('.sq-form-error').remove();
    }

    // go back a step button functions
    function backToMain() {
        $('.feedback-window--type').removeClass('active');
        $('.feedback-window--main').addClass('active');
    }
    function backToType() {
        $('.feedback-window--input').removeClass('active');
        $('.feedback-window--input .feedback__main-option').remove();
        $('.feedback-window--input label').text('');
        $('.feedback__input-form').trigger("reset");
        $('.feedback-window--type').addClass('active');
    }

    // show final success window
    function showSuccessWindow() {
        $('.feedback-window--input').removeClass('active');
        $('.feedback-window--success').addClass('active');
    }

    
    // close feedback window
    $('.feedback-window__wrapper .close').on('click', reset);

    
    // open feedback window when tab clicked, show first window
    $('.feedback-tab__wrapper').on('click', function () {
        $('.feedback').animate({right: "10px"}, 600);
        $('.feedback-window--main').addClass('active');
    })

    // open feedback selection, show second window
    $('.feedback__main-option--feedback').on('click', function () {
        $('.feedback-window--main').removeClass('active');
        $('.feedback-window--input').removeClass('active');
        $('.feedback-window--type').addClass('active');
    })

    // show feedback input, show third window
    $('.feedback-window--type .feedback__main-option').on('click', showFeedbackInputWindow);

    function showFeedbackInputWindow() {
        $('.feedback-window--main').removeClass('active');
        $('.feedback-window--type').removeClass('active');
        $('.feedback-window--input').addClass('active');

        typeOfFeedback = this.dataset.feedbackType;

        // set hidden field value
        $('#sq_form_field_wrapper_q4122_q3 input').val(typeOfFeedback);

        setupInputWindow(typeOfFeedback);
    }

    function setupInputWindow(feedbackType) {
        switch (feedbackType) {
            case 'like':
                $('.feedback-window--input .contact-back').after('<div class="feedback__main-option feedback__main-option--like"><div>I like something</div></div>');

                $('.feedback__input-wrapper label').html('What did you like?');
                break;
            
            case 'dislike':
                $('.feedback-window--input .contact-back').after('<div class="feedback__main-option feedback__main-option--dislike" data-feedback-type="dislike"><div>I don\'t like something</div></div>');

                $('.feedback__input-wrapper label').html('What didn\'t you like?');
                break;
            
            case 'idea':
                $('.feedback-window--input .contact-back').after('<div class="feedback__main-option feedback__main-option--idea" data-feedback-type="idea"><div>I have an idea</div></div>');

                $('.feedback__input-wrapper label').html('What is your suggestion?');
                break;
        }
    }


    // form submit 
    $('.feedback-window--input .sq-form-submit').on('click', function (event) {
        
        // this replicates the formdata sent by the default matrix form, necessary for submission
        var formData = {
            "SQ_FORM_4122_PAGE": 1,
            "q4122:q3": $('#q4122_q3').val(),
            "q4122:q1": $('#q4122_q1').val(),
            "form_email_4122_submit": 'Submit',
        }
        
        $.ajax({
            type: "POST",
            url: $('.feedback-window--input .feedback__input-form').attr('action'),
            data: formData,
            encode: true,
            success: function (data) {
                // 'data' is the html of the Thank you body copy #4331.
                // turn the html string into html and then get the text contents (strip tags)
                var dataTextAsString = $(data).text();
                var successBodyCopy = 'success';
                if (dataTextAsString === successBodyCopy) {
                    showSuccessWindow();
                } else {
                    // if textarea left blank
                    $('#sq_form_field_wrapper_q4122_q1').append('<p id="error_4122_q1" class="sq-form-error"  >This field is required. Please enter a value.</p>')
                }
            },
            error: function (err) {
                console.log('Ajax call err:', err)
            }
        })
        
        event.preventDefault();
        
    });

    // success close button
    $('.feedback-success-close').on('click', reset);


    // back one window buttons
    $('.feedback-window--type .contact').on('click', backToMain);
    $('.feedback-window--input .contact').on('click', backToType);

    // hide feedback if mobile menu open
    let $mobileNavButton = $('.js-toggle-mobile-menu.mobile-menu-button');
    $mobileNavButton.on('click', hideFeedback);

    function hideFeedback() {
        let $menuContainerVisible = $('.js-mobile-menu-target.header-site-menu__container.is-visible');
        if ($menuContainerVisible.length === 1) {
            $('.feedback').animate({ right: '-340px' }, 600);
        } else {
            $('.feedback').animate({ right: '-297px' }, 600);
        }
    }
    
}());